import { Bid, BidTypes } from 'modules/domain/bid/types'
import { CompanyMembersTypes } from 'modules/domain/user/types'
import { getUserPhone } from 'modules/domain/user/utils'
import { getPersonalNumberLabel } from 'modules/utils/numbers/formatPersonalNumber'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router'
import { ARouterLink } from 'views/components/Analytics'
import { KeyValue } from 'views/components/KeyValue/KeyValue'
import { CompanyFactoringIcon } from 'views/components/TooltipIcons/TooltipIcons'
import { TruncatedValue } from 'views/components/TruncatedValue/TruncatedValue'
import { UserLinkWithIcons } from 'views/components/UserLinkWithIcons/UserLinkWithIcons'
import CompanyRoutes from 'views/pages/Company/routes'
import UserRoutes from 'views/pages/User/routes'
import { EntityWithIconsWrapper } from 'views/styled/common'
import APhone from 'views/ui/Phone/APhone'

type Props = {
  bid: Bid
}

export const BidDetailCompanyUser = ({ bid }: Props) => {
  const { t } = useTranslation('common')
  const companyPersonalNumber = `${getPersonalNumberLabel()}: ${bid?.company?.inn || t('common:notSpecified')}`
  const userBidLink = generatePath(UserRoutes.DetailsWithBid, {
    id: String(bid.owner.id),
    bidId: String(bid.id),
    statusBid: bid.status,
  })

  return (
    <KeyValue label={t(`deal:bid_type:${bid.bid_type}`)}>
      <EntityWithIconsWrapper>
        <TruncatedValue hint={bid.company.name}>
          <ARouterLink
            eventName="company"
            itemId={bid.company.id}
            to={generatePath(CompanyRoutes.Details, { id: bid.company.id })}
          >
            {bid.company.name}
          </ARouterLink>
        </TruncatedValue>
        <CompanyFactoringIcon
          company={bid.company}
          profileType={bid.bid_type === BidTypes.sale ? CompanyMembersTypes.seller : CompanyMembersTypes.customer}
        />
      </EntityWithIconsWrapper>
      <div>{companyPersonalNumber}</div>

      <UserLinkWithIcons user={bid.owner} to={userBidLink} />
      <APhone phone={getUserPhone(bid.owner)} />
    </KeyValue>
  )
}
